__turbopack_context__.v({
  "Caption": "index-module__1y6K3q__Caption",
  "Checkbox": "index-module__1y6K3q__Checkbox",
  "CheckboxGroup": "index-module__1y6K3q__CheckboxGroup",
  "Indicator": "index-module__1y6K3q__Indicator",
  "Item": "index-module__1y6K3q__Item",
});
